import { Box, Button, Checkbox, CircularProgress, FormControl, Grid, MenuItem, Autocomplete, Paper, Table, TableBody, TableCell, TableRow, TextField, Typography } from '@mui/material';
import React, { useEffect, useState, useContext } from 'react';
import ButtonTheme from '../../components/ThemeButton/ThemeButton';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ApiService from '../../functions/apiService';
import { useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { useSnackbar } from 'notistack';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import AuthContext from '../../context/AuthContext';
import { toast } from 'react-toastify';
import { Modal, Row, Col } from 'react-bootstrap';
import Select from 'react-select';

export default function AddOverTime({ EmpIds, EmpIds2 , backFunction, loadData, isNightShift = null, setOverTimeModal = {}, allowedVars, is_dn_deparment, isOnlyNightEmployee }) {
  const { user, pages } = useContext(AuthContext);
  const [users, setUsers] = useState();
  const [overtimes, setOvertimes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [onlyDay, setOnlyDay] = useState(false);
  const [countAction, setCountAction] = useState(0);
  const [inStart, setInStart] = useState(true);
  const [newShifts, setNewShifts] = useState([]);
  const [isErrorTime, setIsErrorTime] = useState(false)
  const [customData, setCustomData] = useState(false);
  const data = useSelector((state) => state.dashboardReducer.Data)
  const Shifts = useSelector((state) => state.dashboardReducer.Shifts)
  const AbsentReasonAll = useSelector((state) => state.dashboardReducer.AbsentReasonAll)
  const EmployeeToSwap = useSelector((state) => state.dashboardReducer.EmployeeToSwap)
  const [startTime, setStartTime] = useState(null)
  const [endTime, setEndTime] = useState(null)
  const [canSubmit, setCanSubmit] = useState(false)
  const [payCode, setPayCode] = useState([])

  const { register, formState: { errors }, handleSubmit, setError, setValue, getValues, watch } = useForm({
    defaultValues: {
      ShiftCode: '',
      SelAbsent: '',
      SelEmp: ''
    }
  });
  watch('SelAbsent', 'SelEmp')

  let loadEmployee = () => {
    ApiService.post('/getEmployees', { EmpIds: EmpIds && EmpIds.length > 0 ? EmpIds : EmpIds2 , date: moment(data.date).format('YYYY-MM-DD') }).then((data) => {
      if (data.length == 1) {
        if (data[0].employee_assignment.Group_Code.includes('DAY')) {
          setOnlyDay(true)
        }
      }
      setUsers(data)
      setOvertimes(data.map(i => {
        let employee_fullname = i.employee_assignment.EA_Rank + ' ' + i.First_name + ' ' + i.Last_name;
        return [...i.overtime_shifts.map(x => { return { ...x, employee_fullname: employee_fullname } })]
      }).flat())
      setLoading(false)
    }).catch(() => {
      toast.error('Error')
      setLoading(false)
    })
  }

  useEffect(() => {
    if (EmpIds && EmpIds.length > 0 || EmpIds2 && EmpIds2.length > 0) {
      loadEmployee()
    }
  }, [])

  useEffect(() => {
    if (countAction == 0) {
      setSaving(false)
      if (!inStart) {
        toast.success("Added Successfully")
        loadData(moment(data.date).format('DD-MM-YYYY'))
        backFunction()
      }
    }
  }, [countAction])

  const predefinedShifts = [
    { ShiftCode: 92, Shift: "08:00 - 12:00", StartTime: "08:00:00", EndTime: "12:00:00" },
    { ShiftCode: 93, Shift: "08:00 - 13:00", StartTime: "08:00:00", EndTime: "13:00:00" },
    { ShiftCode: 94, Shift: "13:00 - 18:00", StartTime: "13:00:00", EndTime: "18:00:00" },
    { ShiftCode: 95, Shift: "14:00 - 18:00", StartTime: "14:00:00", EndTime: "18:00:00" },
    { ShiftCode: 96, Shift: "18:00 - 22:00", StartTime: "18:00:00", EndTime: "22:00:00" },
    { ShiftCode: 97, Shift: "18:00 - 01:00", StartTime: "18:00:00", EndTime: "01:00:00" },
    { ShiftCode: 98, Shift: "01:00 - 08:00", StartTime: "01:00:00", EndTime: "08:00:00" }
  ];

  let onSubmit = async (e) => {
    setSaving(true);
    setInStart(false);

    Object.values(EmpIds && EmpIds.length > 0 ? EmpIds : EmpIds2).map(emp => {
      setCountAction(prevVal => prevVal + 1);
      let start = '';
      let end = '';
      let shiftCode = e.ShiftCode;

      if (customData) {
        start = startTime.toString().split(' ')[4];
        end = endTime.toString().split(' ')[4];
        shiftCode = 91;
      }
      else {
        const predefinedShift = predefinedShifts.find(shift => shift.ShiftCode === e.ShiftCode);

        if (predefinedShift) {
          start = predefinedShift.StartTime;
          end = predefinedShift.EndTime;
          shiftCode = predefinedShift.ShiftCode > 91 ? 91 : predefinedShift.ShiftCode;
        }
        else {
          const selectedShift = Shifts.find(item => item.ShiftCode == e.ShiftCode);
          if (selectedShift) {
            start = selectedShift.Start_Time;
            end = selectedShift.End_Time;
          } else {
            toast.error("Invalid Shift Selection");
            setSaving(false);
            return;
          }
        }
      }

      ApiService.post('/postAdminAddOvertime', {
        "EmpCode": emp,
        "RequestDate": moment(data.date).format('YYYY-MM-DD'),
        "ShiftCode": shiftCode,
        "SelAbsent": e.SelAbsent,
        "StartTime": start,
        "EndTime": end,
        "SelEmp": e.SelEmp,
        "Comment": e.Comment,
        ...(allowedVars && Object.keys(allowedVars).includes('V3_PAYCODE_IN_OT') && {
          Pay_Code: e.Pay_Code
        })
      }).then(() => {
        setCountAction(prevVal => prevVal - 1);
      }).catch((error) => {
        setSaving(false);
        toast.error(error?.data?.message);
      });
    });
  };

  useEffect(() => {
    if (isNightShift != null) {
      var check24Shifts = Shifts.filter((shift) => shift.Short_Desc == '24')

      if (check24Shifts.length > 0) {
        setNewShifts(Shifts)
      }
      else if (isNightShift == true) {
        var tempShifts = Shifts.filter((shift) => shift.Short_Desc == 'night' || shift.Shift_Hours == 7 || shift.Short_Desc == '24')
        setNewShifts(tempShifts)
      }
      else if (isNightShift == false) {
        if(isOnlyNightEmployee == true && is_dn_deparment == 'DN_24_VIEW'){
          var tempShifts = Shifts.filter((shift) => shift.Short_Desc == 'night' || shift.Shift_Hours == 7 || shift.Short_Desc == '24')
          setNewShifts(tempShifts)
        }else{
          var tempShifts = Shifts.filter((shift) => shift.Short_Desc == 'day' || shift.Shift_Hours == 5 || shift.Short_Desc == '24')
          setNewShifts(tempShifts)
        }
        
      }
    }
  }, [isNightShift])

  useEffect(() => {
    // disabled = { saving || !getValues('ShiftCode') || getValues('ShiftCode') == '' ||
    //         !getValues('SelAbsent') || getValues('SelAbsent') == '' ||
    //         (getValues('SelAbsent').includes('SWAP') && watch('SelEmp') == '')
    // }
    if (customData) {
      if (startTime && endTime && getValues('SelAbsent') && getValues('SelAbsent') != '') {
        setCanSubmit(true)
      }
      else {
        setCanSubmit(false)
      }
    }
    else if (getValues('ShiftCode') || getValues('ShiftCode') != '' || getValues('SelAbsent') || getValues('SelAbsent') != '' || !getValues('SelAbsent').includes('SWAP') && watch('SelEmp') != '') {
      setCanSubmit(true)
    }
    else {
      setCanSubmit(false)
    }

  }, [getValues('ShiftCode'), getValues('SelAbsent'), customData, startTime, endTime])

  const getPayCodeList = async () => {
    setLoading(true);
    try {
      const response = await ApiService.get("/payroll/pay-code", {
      });
      setPayCode(response?.data || [])
    } catch (error) {
      console.error(error.data)
    }
    finally {
      setLoading(false)
    }
  };

  useEffect(() => {
    getPayCodeList()
  }, [])


  return (
    <>
      <Paper className='p-4'>
        <Box>
          <Button className=' text-decoration-none my-2' onClick={backFunction} style={{ color: '#555555', paddingLeft: "0px" }}> <ArrowBackIosIcon /> Back</Button>
        </Box>
        {!loading &&
          <>
            <Typography fontWeight={700} fontSize={21} className="mb-3">{moment(data.date).format("dddd Do MMMM YYYY")}</Typography>
            <div className='border border-1 rounded-2 p-4' style={{ width: 'fit-content' }}>
              <p className=' fw-bolder text-danger '>Selected Members</p>
              {
                users && users.map(user => {
                  return (<Typography key={user.Emp_Code} fontWeight={700} fontSize={16}>{user?.employee_assignment?.EA_Rank + ' ' + user.fullName + ' (' + user?.employee_assignment?.AssignmentName + ' - ' + user?.employee_assignment?.Position + ' )'}</Typography>)
                })
              }
            </div>
            {!loading && overtimes.length > 0 &&
              <div className='my-2'>
                <Typography fontWeight={700} fontSize={21}>Existing Schedule Overrides</Typography>
                <OverTimeForm loadEmployee={loadEmployee} loadData={loadData}
                  overtimes={overtimes} setOvertimes={setOvertimes} backFunction={backFunction}
                  pages={pages} payCode={payCode} />
                <hr />
              </div>
            }
            <form onSubmit={handleSubmit(onSubmit)}>
              <FormControl className='w-100'>
                <Grid item xs={2}>
                  <Typography fontWeight={700} fontSize={21} className="mt-3">Add Time Off</Typography>
                </Grid>
                <Grid className='mt-1' container spacing={2}>
                  <Grid item xs={12} sm={12} md={6}>
                    <label className='my-1' style={{ fontSize: '14px' }}>Shift</label>
                    <TextField
                      {...register('ShiftCode', { required: true })}
                      className='mt-0 w-100'
                      color='secondary'
                      variant="outlined"
                      select
                      size='small'
                      label="Shift"
                      InputProps={{
                        sx: { height: '48px', fontSize: '14px' }
                      }}
                      InputLabelProps={{
                        sx: { marginTop: '3px', fontSize: '14px' },
                      }}
                      onChange={(e) => {
                        setCustomData(e.target.value === 'custom');
                      }}
                    >
                      {/* <MenuItem value=''>Please Select</MenuItem> */}
                      {!onlyDay && newShifts?.map((option) => (
                        <MenuItem value={option.ShiftCode} key={option.ShiftCode + 'notOnlyDay'} >{option.Shift} </MenuItem>
                      ))}
                      {onlyDay && newShifts?.map((option) => {
                        if (option.Shift == 'Day') {
                          return (
                            <MenuItem value={option.ShiftCode} key={option.ShiftCode + 'onlyDay'} >{option.Shift} </MenuItem>
                          )
                        }
                      })}
                      {(pages && pages.includes('V3_CUSTOM_TIME_PRESETS')) &&
                        (
                          predefinedShifts.map((shift) => (
                            <MenuItem value={shift.ShiftCode} key={shift.ShiftCode}>
                              {shift.Shift}
                            </MenuItem>
                          ))
                        )}

                      {newShifts.length == 0 && Shifts?.map((option) => (
                        <MenuItem value={option.ShiftCode} key={option.ShiftCode} >{option.Shift} </MenuItem>
                      ))}

                      {(pages && pages.includes('SCHEDULE_CUSTOM_SHIFTS')) && newShifts.length > 0 && <MenuItem value='custom'>Custom</MenuItem>}

                    </TextField>
                    {errors.ShiftCode && <p style={{ color: 'red' }}>{errors.ShiftCode?.message}</p>}
                  </Grid >

                  {customData && (
                    <Grid item xs={12} sm={12} md={3}>
                      <label className="my-1" style={{ fontSize: '14px' }}>From</label>
                      <Box>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                          <TimePicker
                            className="m-0"
                            timeSteps={{ minutes: 30 }}
                            value={startTime}
                            onChange={(newValue) => setStartTime(newValue)}
                            sx={{
                              "& .MuiOutlinedInput-input": { color: 'red' },
                              width: "100%",
                              "& .MuiInputBase-root": {
                                height: '48px',
                                fontSize: '14px'
                              },
                            }}
                          />
                        </LocalizationProvider>
                      </Box>
                    </Grid>
                  )}

                  {
                    customData && (
                      <Grid item xs={12} sm={12} md={3}>
                        <label className='my-1' style={{ fontSize: '14px' }}>To</label>
                        <Box>
                          <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <TimePicker
                              className='m-0'
                              timeSteps={{ minutes: 30 }}
                              value={endTime}
                              onChange={(newValue) => setEndTime(newValue)}
                              sx={{
                                "& .MuiOutlinedInput-input": { color: isErrorTime && 'red' },
                                width: "100%",
                                "& .MuiInputBase-root": {
                                  height: '48px',
                                  fontSize: '14px'
                                },
                              }}
                            />
                          </LocalizationProvider>
                        </Box>
                      </Grid>
                    )
                  }

                  <Grid item xs={12} sm={12} md={6}>
                    <label className='my-1' style={{ fontSize: '14px' }}>PTO Type</label>
                    {AbsentReasonAll &&
                      <Autocomplete
                        {...register('SelAbsent')}
                        className="mt-0 w-100"
                        options={Object.entries(AbsentReasonAll)}
                        onChange={(event, value) => {
                            setValue('SelAbsent', value ? value[0] : '');
                        }}
                        getOptionLabel={(option) => option[1]}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="PTO Type"
                            variant="outlined"
                            size="small"
                            InputProps={{
                              ...params.InputProps,
                              sx: {
                                height: '48px',
                                fontSize: '14px',
                              },
                            }}
                            InputLabelProps={{
                              sx: {
                                marginTop: '3px',
                                fontSize: '14px',
                              },
                            }}
                          />
                        )}
                        renderOption={(props, option) => (
                          <li {...props} key={option[0]}>
                            {option[1]}
                          </li>
                        )}
                        isOptionEqualToValue={(option, value) => option[0] === value}
                        disableClearable
                      />
                    }
                    {errors.SelAbsent && <p style={{ color: 'red' }}>{errors.SelAbsent?.message}</p>}
                  </Grid>

                  {(allowedVars && Object.keys(allowedVars).includes('V3_PAYCODE_IN_OT')) &&
                    <Grid item xs={12} sm={12} md={6}>
                      <label className='my-1' style={{ fontSize: '14px' }}>Pay Code</label>
                      <TextField
                        {...register('Pay_Code')}
                        className='mt-0 w-100 testFieldStyle'
                        displayValue='label'
                        label="Select Pay Code"
                        options={payCode.map((item) => ({
                          label: item.SO_Desc,
                          value: item.SO_Value,
                        }))
                        }
                        color="secondary"
                        variant="outlined"
                        select
                        size='small'
                        InputProps={{
                          sx: { height: '48px', fontSize: '14px' }
                        }}
                        InputLabelProps={{
                          sx: { marginTop: '3px', fontSize: '14px' },
                        }}
                      >
                        <MenuItem value={"STRAIGHT"}>
                          Straight
                        </MenuItem>
                        <MenuItem value={"OVERTIME"}>
                          Overtime
                        </MenuItem>
                        {payCode.map((item) => (
                          <MenuItem key={item.SO_Value} value={item.SO_Value}>
                            {item.SO_Desc}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>
                  }

                  <Grid item xs={12} sm={12} md={6} key='SWAP' className={`${getValues('SelAbsent') && getValues('SelAbsent').includes('SWAP') ? '' : 'd-none'}`}>
                    <label className='my-1' style={{ fontSize: '14px' }}>Swap Employee</label>
                    {AbsentReasonAll &&
                      <Autocomplete
                        {...register('SelEmp')}
                        className="mt-0 w-100"
                        options={EmployeeToSwap || []}
                        getOptionLabel={(option) => option.EA_Rank + ' ' + option.fullName}
                        onChange={(event, value) => {
                          setValue('SelEmp', value ? value.Emp_Code : '');
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Employee"
                            variant="outlined"
                            size="small"
                            InputProps={{
                              ...params.InputProps,
                              sx: {
                                height: '48px',
                                fontSize: '14px',
                              },
                            }}
                            InputLabelProps={{
                              sx: {
                                marginTop: '3px',
                                fontSize: '14px',
                              },
                            }}
                          />
                        )}
                        isOptionEqualToValue={(option, value) => option.Emp_Code === value}
                      />
                    }
                    {errors.SelEmp && <p style={{ color: 'red' }}>{errors.SelEmp?.message}</p>}
                  </Grid>
                </Grid >
                {
                  pages.includes('V3_RTO_COMMENT') &&
                  <>
                    <label className='mb-1 mt-2' style={{ fontSize: '14px' }}>Comment <span style={{ fontSize: '12px', color: '#333' }}>(Only 256 characters are allowed)</span></label>
                    <TextField
                      {...register("Comment")}
                      className="mt-0 w-100"
                      color="secondary"
                      variant="outlined"
                      label="Comment"
                      multiline
                      inputProps={{ maxLength: 256 }}
                      sx={{
                        '& .MuiInputBase-root': {
                          fontSize: '14px !important'
                        }
                      }}
                    />
                  </>
                }
                {/* <div className='my-3 col-12'>
                    <ButtonTheme 
                        disabled={getValues('status') == false || getValues('type') == false || saving || (getValues('status') == 'F' && watch('FillEmp') == false && !getValues('type').includes('SWAP')) || (getValues('status') == 'R' && watch('FillEmp') == false && !getValues('type').includes('SWAP'))} 
                        onClick={handleSubmit(onSubmitSaveEdit)} 
                        type='submit' variant="filled" color='primary' className='px-5 my-3'>
                        Save
                    </ButtonTheme>
                    <ButtonTheme onClick={cancelEdit} type='button' variant="filled" color='primary' className='px-5 my-3 mx-2'>
                        Cancel
                    </ButtonTheme>
                </div> */}
                <Box className="pt-3">
                  <ButtonTheme
                    disabled={saving || !canSubmit}
                    type='submit' variant="filled" color='primary' className='px-5'>
                    {saving && 'Loading...'}
                    {!saving && 'Save'}
                  </ButtonTheme>
                </Box >
              </FormControl >
            </form >

          </>
        }
      </Paper >
    </>
  )
}



const OverTimeForm = ({ overtimes, setOvertimes, backFunction, loadData, loadEmployee, pages, payCode }) => {
  const { register, formState: { errors }, handleSubmit, setError, setValue, getValues, watch, reset } = useForm({
    defaultValues: {
      ShiftNumber: false
    }
  });
  watch(['ShiftNumber', 'status', 'type'])
  const AbsentReasonAll = useSelector((state) => state.dashboardReducer.AbsentReasonAll);
  const EmployeeToSwap = useSelector((state) => state.dashboardReducer.EmployeeToSwap)
  const data = useSelector((state) => state.dashboardReducer.Data);
  const [editMode, setEditMode] = useState(false);
  const [saving, setSaving] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [delReasonModal, setDelReasonModal] = useState(false)
  const [reason, setReason] = useState(false)
  const [selectedShifts, setSelectedShifts] = useState([])
  const [deleteEvent, setDeleteEvent] = useState('')
  const [editEvent, setEditEvent] = useState('')
  const [origSelectedRow, setOrigSelectedRow] = useState('')
  const [allowedVars, setAllowedVars] = useState([])
  const [confirmPTOTypeChangeModal, setConfirmPTOTypeChangeModal] = useState(false);
  const [keepHours, setKeepHours] = useState(false);
  const defaultKeepHours = allowedVars?.V3_AUTO_CHECKED_KEEP_HOURS_CHECKBOX == 'true';

  useEffect(() => {
    setKeepHours(defaultKeepHours)
  }, [defaultKeepHours])

  let getAllowedVars = () => {
    ApiService.get('/v3Variables')
      .then((res) => {
        setAllowedVars(res?.data?.data)
      }).catch(({ error }) => {
        console.log('error', error)
      });
  }

  useEffect(() => {
    getAllowedVars()
  }, [])

  const handleRowSelection = (shift) => {
    setSelectedRow(shift);
    var tempShifts = [...selectedShifts];
    let index = tempShifts.findIndex(e => e.Shift_Number == shift.Shift_Number);
    if (index === -1) {
      tempShifts.push(shift);
    } else {
      tempShifts.splice(index, 1);
    }
    setSelectedShifts(tempShifts);

    setValue('ShiftNumber', tempShifts.map(s => s.Shift_Number));
  };

  useEffect(() => {
    setValue('FillEmp', false)
  }, [editMode])

  let onSubmit = (e) => {
    setEditMode(true);
  }

  let onSubmitDelete = (e) => {
    if (allowedVars && Object.keys(allowedVars).includes('V3_FILL_REMOVE_REASON_ENABLED')) {
      if (selectedShifts?.find(sh => sh.Status == 'F') !== undefined) {
        setDelReasonModal(true)
        setDeleteEvent(e)
      }
      else {
        deleteEmpOt(e)
      }
    }
    else {
      deleteEmpOt(e)
    }
  }

  let deleteEmpOt = (e, isReason = false) => {
    let tempData = e != null ? e : deleteEvent
    if (!Array.isArray(tempData.ShiftNumber)) {
      tempData.ShiftNumber = [tempData.ShiftNumber];
    }
    if (isReason) {
      tempData.Reject_Reason = reason
    }
    tempData.keep_hours = keepHours ? 1 : 0
    setOvertimes(pre => pre.filter(i => !tempData.ShiftNumber.includes(i.Shift_Number.toString())))
    ApiService.delete('/deleteEmployeesOvertime', { ...tempData, date: moment(data.date).format('YYYY-MM-DD') })
      .then(() => {
        toast.success("Deleted sucessfully")
        loadData(moment(data.date).format('DD-MM-YYYY'))
        setDelReasonModal(false)
        setKeepHours(defaultKeepHours)
        backFunction()
      }).catch(() => {
        toast.error("Error")
      })
  }

  let onSubmitSaveEdit = (e) => {
    if (!Array.isArray(e.ShiftNumber)) {
      e.ShiftNumber = [e.ShiftNumber];
    }

    e.Start_Time = e.Start_Time instanceof Date
    ? moment(e.Start_Time).format("HH:mm:ss")
    : (e.Start_Time || selectedRow?.Start_Time);

    e.End_Time = e.End_Time instanceof Date
      ? moment(e.End_Time).format("HH:mm:ss")
      : (e.End_Time || selectedRow?.End_Time);

    if (!['F', 'R'].includes(e.status)) {
      e.SelEmp = '';
    }

    e.keep_hours = keepHours ? 1 : 0

    if((allowedVars && Object.keys(allowedVars).includes('SCHEDULE_WARN_PTO_TYPE_CHANGE')) && selectedRow.Absent_Code !== e.type) {
      setEditEvent(e)
      setOrigSelectedRow(selectedRow)
      setConfirmPTOTypeChangeModal(true)
    }
    else {
      setSaving(true)
      ApiService.post('/editEmployeesOvertime', { ...e, date: moment(data.date).format('YYYY-MM-DD') })
        .then((res) => {
          setEditMode(false);
          reset()
          setSaving(false)
          loadData(moment(data.date).format('DD-MM-YYYY'))
          toast.success(res?.message)
          loadEmployee()
          setSelectedShifts([])
          setKeepHours(defaultKeepHours)
          backFunction();
        }).catch((error) => {
          setSaving(false)
          toast.error(error?.data?.message)
        })
    }
  }

  let cancelEdit = () => {
    setEditMode(false)
    setValue('ShiftNumber', '')
    setKeepHours(defaultKeepHours)
  }

  useEffect(() => {
    if (selectedRow && selectedRow.Absent_Code) {
      const value = Object.entries(AbsentReasonAll).find(([key]) => key === selectedRow.Absent_Code);
      setValue('type', value ? value[0] : '');
    }
  }, [selectedRow && selectedRow.Absent_Code, setValue]);

  const handleChange = (event, value) => {
    setValue('type', value ? value[0] : (selectedRow && selectedRow.Absent_Code
      ? Object.entries(AbsentReasonAll).find(([key]) => key === selectedRow && selectedRow.Absent_Code)
      : ''
    ));
  };

  useEffect(() => {
		if (selectedRow?.FilledEmployeeCode) {
			setValue("FillEmp", selectedRow.FilledEmployeeCode);
			setValue("SelEmp" , selectedRow.FilledEmployeeCode);
		}
	}, [selectedRow, setValue , editMode]);


  return <>
    {!editMode &&
      <form>
        <div style={{ border: '1px solid rgba(224, 224, 224, 1)', borderRadius: '8px', marginTop: '10px' }}>
          <Table sx={{ minWidth: '100%', maxWidth: '100%' }} aria-label="simple table">
            <TableBody>
              {overtimes.map((shift) => {
                const selectedAbsentCode =
                  selectedShifts.length > 0 ? selectedShifts[0].Absent_Code : null;

                const selectedEmployeeCode =
                  selectedShifts.length > 0 ? selectedShifts[0].FilledEmployeeCode : null;

                const isAlreadySelected = selectedShifts.some(
                  (e) => e.Shift_Number == shift.Shift_Number
                );

                const isDisabled =
                  selectedShifts.length > 0 &&
                  !isAlreadySelected &&
                  (shift.Absent_Code !== selectedAbsentCode ||
                    shift.FilledEmployeeCode !== selectedEmployeeCode);

                return(
                  <TableRow
                    key={shift.Shift_Number + shift.Shift_Number + 'overtimes'}
                    sx={{ 
                      '&:last-child td, &:last-child th': { border: 0 },
                      opacity: isDisabled ? 0.4 : 1,
                      pointerEvents: isDisabled ? 'none' : 'auto'
                    }}
                  >
                    <TableCell component="th" scope="row" sx={{ width: '10px', padding: '10px', flexGrow: 1, display: 'table-cell' }}>
                       <Checkbox 
                          {...register('ShiftNumber')} 
                          value={shift.Shift_Number} 
                          label={`Day ${shift.Shift_Number}`}
                          disabled={isDisabled}
                          checked={selectedShifts.some(e => e.Shift_Number == shift.Shift_Number)}
                          onChange={() => handleRowSelection(shift)}
                      />
                    </TableCell>
                    <TableCell align="left" sx={{ width: '160px', padding: '10px', flexGrow: 1, display: 'table-cell' }}>
                      {shift.employee_fullname}
                    </TableCell>
                    <TableCell align="left" sx={{ width: shift.Shift_Code == 91 ? '190px' : '80px', padding: '10px', flexGrow: 1, display: 'table-cell' }}>
                      {shift.Shift_Code === 3
                        ? 'Night'
                        : shift.Shift_Code === 91
                          ? `${shift.Shift_Type}(${shift.Start_Time} - ${shift.End_Time})`
                          : shift.Shift_Code === 2 ? 'Day' : `${shift.Shift_Type}(${shift.Start_Time} - ${shift.End_Time})`}
                    </TableCell>
                    {allowedVars && Object.keys(allowedVars).includes('V3_PAYCODE_IN_OT') && shift?.paycode?.Value &&
                      <TableCell align="left" sx={{ width: '180px', padding: '10px', flexGrow: 1, display: 'table-cell' }}>
                        Pay Code : {payCode?.find((item) => item?.SO_Value == shift?.paycode?.Value)?.SO_Desc || shift?.paycode?.Value}
                      </TableCell>
                    }
                    <TableCell align="left" sx={{ width: '100px', padding: '10px', flexGrow: 1, display: 'table-cell' }}>
                      {shift.AbsentText}
                    </TableCell>
                    <TableCell align="left" sx={{ width: '100px', padding: '10px', flexGrow: 1, display: 'table-cell' }}>
                      {shift.StatusText} {shift.FilledEmployee}
                    </TableCell>
                    {pages.includes('V3_RTO_COMMENT') &&
                      <TableCell sx={{ width: 'auto', padding: '10px' }}>{shift.comment?.Value || ""}</TableCell>
                    }
                  </TableRow>
                )
              })}

            </TableBody>
          </Table>
        </div>

        <div className='my-3' style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <ButtonTheme disabled={selectedShifts.length === 0}  onClick={handleSubmit(onSubmit)} type='submit' variant="filled" color='primary' className='px-5 '>
            Edit
          </ButtonTheme>
          <ButtonTheme disabled={selectedShifts.length === 0}  onClick={handleSubmit(onSubmitDelete)} type='submit' variant="filled" color='primary' className='px-5'>
            Delete
          </ButtonTheme>
          {allowedVars?.V3_ALLOW_KEEP_OSL_HOURS === 'true' && (
            <Box sx={{ display: 'flex', alignItems: 'center', ml: 1 }}>
              <Checkbox
                checked={keepHours}
                onChange={(e) => setKeepHours(e.target.checked)}
                size="small"
              />
              <label style={{ fontSize: '14px', cursor: 'pointer' }} onClick={() => setKeepHours(!keepHours)}>
                Keep assigned hours
              </label>
            </Box>
          )}
        </div>

      </form>
    }
    {editMode &&
      <form className='row'>
        <div className='col-12 col-md-6'>
          <label className='my-1' style={{ fontSize: '14px' }}>Status</label>
          <TextField
            label="Status"
            defaultValue={selectedRow.Status === null || '' ? '' : selectedRow.Status}
            {...register("status")}
            className='my-2 w-100 ' color='secondary' variant="outlined"
            InputProps={{
              sx: {
                height: '48px',
                fontSize: '14px'
              }
            }}
            InputLabelProps={{
              sx: {
                marginTop: '3px',
                fontSize: '14px'
              },
            }}
            select
          >
            <MenuItem value={"D"} key={"D"}>
              Do Not Fill
            </MenuItem>
            <MenuItem value={"F"} key={"F"}>
              Filled
            </MenuItem>
            <MenuItem value={"O"} key={"O"}>
              Open
            </MenuItem>
            <MenuItem value={"Q"} key={"Q"}>
              Requested
            </MenuItem>
            <MenuItem value={"R"} key={"R"}>
              Ordered
            </MenuItem>
          </TextField>
        </div>
        <div className='col-12 col-md-6'>
          <label className='my-2' style={{ fontSize: '14px' }}>PTO Type</label>
          {AbsentReasonAll &&
            <Autocomplete
              {...register('type')}
              className="mt-0 w-100"
              options={Object.entries(AbsentReasonAll)}
              defaultValue={selectedRow.Absent_Code ? Object.entries(AbsentReasonAll).find(([key]) => key === selectedRow.Absent_Code) : null}
              onChange={handleChange}
              getOptionLabel={(option) => option[1]}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="PTO Type"
                  variant="outlined"
                  size="small"
                  InputProps={{
                    ...params.InputProps,
                    sx: {
                      height: '48px',
                      fontSize: '14px',
                    },
                  }}
                  InputLabelProps={{
                    sx: {
                      marginTop: '3px',
                      fontSize: '14px',
                    },
                  }}
                />
              )}
              renderOption={(props, option) => (
                <li {...props} key={option[0]}>
                  {option[1]}
                </li>
              )}
              isOptionEqualToValue={(option, value) => option[0] === value}
              disableClearable
            />
          }
        </div>

        {(allowedVars && Object.keys(allowedVars).includes('V3_PAYCODE_IN_OT')) &&
          <div className='col-12 col-md-6'>
            <label className='my-1' style={{ fontSize: '14px' }}>Pay Code</label>
            <TextField
              {...register('Pay_Code')}
              defaultValue={selectedRow?.paycode === null || '' ? '' : selectedRow?.paycode?.Value}
              className='mt-0 w-100 testFieldStyle'
              displayValue='label'
              label="Select Pay Code"
              options={payCode.map((item) => ({
                label: item.SO_Desc,
                value: item.SO_Value,
              }))}
              color="secondary"
              variant="outlined"
              select
              size='small'
              InputProps={{
                sx: { height: '48px', fontSize: '14px' }
              }}
              InputLabelProps={{
                sx: { marginTop: '3px', fontSize: '14px' },
              }}
            >
              <MenuItem value={"STRAIGHT"}>
                Straight
              </MenuItem>
              <MenuItem value={"OVERTIME"}>
                Overtime
              </MenuItem>
              {payCode.map((item) => (
                <MenuItem key={item.SO_Value} value={item.SO_Value}>
                  {item.SO_Desc}
                </MenuItem>
              ))}
            </TextField>
          </div>
        }

        {selectedRow?.Shift_Code == 91 && allowedVars?.V3_UPDATE_OVERTIME_CUSTOM_TIME &&
          <div className='col-12 col-md-3'>
            <label className='my-1' style={{ fontSize: '14px' }}>Start Time</label>
            <Box>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <TimePicker
                  className="m-0"
                  timeSteps={{ minutes: 30 }}
                  onChange={(value) => {
                    setValue("Start_Time", value);
                  }}
                  defaultValue={
                    selectedRow?.Start_Time
                      ? new Date(`1970-01-01T${selectedRow.Start_Time}`)
                      : null
                  }
                  sx={{
                    width: "100%",
                    "& .MuiInputBase-root": {
                      height: '48px',
                      fontSize: '14px'
                    },
                  }}
                />
              </LocalizationProvider>
            </Box>
          </div>
        }

        {selectedRow?.Shift_Code == 91 && allowedVars?.V3_UPDATE_OVERTIME_CUSTOM_TIME &&
          <div className='col-12 col-md-3'>
            <label className='my-1' style={{ fontSize: '14px' }}>End Time</label>
            <Box>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <TimePicker
                  className="m-0"
                  timeSteps={{ minutes: 30 }}
                  onChange={(value) => {
                    setValue("End_Time", value);
                  }}
                  defaultValue={
                    selectedRow?.End_Time
                      ? new Date(`1970-01-01T${selectedRow.End_Time}`)
                      : null
                  }
                  sx={{
                    width: "100%",
                    "& .MuiInputBase-root": {
                      height: "48px",
                      fontSize: "14px"
                    },
                  }}
                />
              </LocalizationProvider>
            </Box>
          </div>
        }

        <div className={`${getValues('status') && getValues('status') == "F" && !getValues('type').includes('SWAP') || getValues('status') == "R" && !getValues('type').includes('SWAP') ? 'col-12 col-md-6' : 'col-12 col-md-6 d-none'}`}>
          <label className='my-1' style={{ fontSize: '14px' }}>Employee to fill</label>
          {AbsentReasonAll &&
            <Autocomplete
              {...register('FillEmp')}
              className="mt-0 w-100"
              options={EmployeeToSwap || []}
              getOptionLabel={(option) => option.EA_Rank + ' ' + option.fullName}
              defaultValue={
                EmployeeToSwap?.find(
                  (emp) => emp.Emp_Code === selectedRow?.FilledEmployeeCode
                ) || null
              }
              onChange={(event, value) => {
                setValue('FillEmp', value ? value.Emp_Code : '');
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Employee"
                  variant="outlined"
                  size="small"
                  InputProps={{
                    ...params.InputProps,
                    sx: {
                      height: '48px',
                      fontSize: '14px',
                    },
                  }}
                  InputLabelProps={{
                    sx: {
                      marginTop: '3px',
                      fontSize: '14px',
                    },
                  }}
                />
              )}
              isOptionEqualToValue={(option, value) => option.Emp_Code === value}
              disableClearable
            />
          }
          {errors.SelEmp && <p style={{ color: 'red' }}>{errors.SelEmp?.message}</p>}
        </div>

        <div className={`${getValues('type') && getValues('type').includes('SWAP') ? 'col-12 col-md-6' : 'col-12 col-md-6 d-none'}`}>
          <label className='my-1' style={{ fontSize: '14px' }}>Swap Employee</label>
          {AbsentReasonAll &&
            <Autocomplete
              {...register('SelEmp')}
              className="mt-0 w-100"
              options={EmployeeToSwap || []}
              getOptionLabel={(option) => option.EA_Rank + ' ' + option.fullName}
              defaultValue={
                EmployeeToSwap?.find(
                  (emp) => emp.Emp_Code === selectedRow?.FilledEmployeeCode
                ) || null
              }
              onChange={(event, value) => {
                setValue('SelEmp', value ? value.Emp_Code : '');
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Employee"
                  variant="outlined"
                  size="small"
                  InputProps={{
                    ...params.InputProps,
                    sx: {
                      height: '48px',
                      fontSize: '14px',
                    },
                  }}
                  InputLabelProps={{
                    sx: {
                      marginTop: '3px',
                      fontSize: '14px',
                    },
                  }}
                />
              )}
              isOptionEqualToValue={(option, value) => option.Emp_Code === value}
              disableClearable
            />
          }
          {errors.SelEmp && <p style={{ color: 'red' }}>{errors.SelEmp?.message}</p>}
        </div>
        {pages.includes('V3_RTO_COMMENT') &&
          <div className='col-12'>
            <label className='my-1' style={{ fontSize: '14px' }}>Comment <span style={{ fontSize: '12px', color: '#333' }}>(Only 256 characters are allowed)</span></label>
            <TextField
              {...register("Comment")}
              className="mt-0 w-100"
              color="secondary"
              variant="outlined"
              label=""
              multiline
              inputProps={{ maxLength: 256 }}
              defaultValue={selectedRow.comment === null ? '' : selectedRow.comment.Value}
              sx={{
                '& .MuiInputBase-root': {
                  fontSize: '14px !important'
                }
              }}
            />
          </div>
        }
        <div className='my-3 col-12' style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <ButtonTheme
            disabled={getValues('status') == false || getValues('type') == false || saving || (getValues('status') == 'F' && watch('FillEmp') == false && !getValues('type').includes('SWAP')) || (getValues('status') == 'R' && watch('FillEmp') == false && !getValues('type').includes('SWAP'))}
            onClick={handleSubmit(onSubmitSaveEdit)}
            type='submit' variant="filled" color='primary' className='px-5'>
            Save
          </ButtonTheme>
          <ButtonTheme onClick={cancelEdit} type='button' variant="filled" color='primary' className='px-5'>
            Cancel
          </ButtonTheme>
          {allowedVars?.V3_MANUAL_ALLOW_KEEP_OSL_HOURS === 'true' && (
            <Box sx={{ display: 'flex', alignItems: 'center', ml: 1 }}>
              <Checkbox
                checked={keepHours}
                onChange={(e) => setKeepHours(e.target.checked)}
                size="small"
              />
              <label style={{ fontSize: '14px', cursor: 'pointer' }} onClick={() => setKeepHours(!keepHours)}>
                Keep assigned hours
              </label>
            </Box>
          )}
        </div >
      </form >
    }
    <Modal show={delReasonModal} onHide={() => setDelReasonModal(false)}>
      <Modal.Header closeButton>
        <Modal.Title>{selectedShifts?.find(a => a.Status == 'F')?.employee_fullname || ''}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div style={{ color: 'black', marginBottom: '10px' }}>
          Please select a reason for deletion from the list below -:
        </div>

        <Col md={12}>
          <Row>
            <Col md='auto' className='p-0'>
              <Checkbox label={'hr'}
                checked={reason == 'OPERATIONAL'} OPERATIONAL
                onClick={() => setReason((val) => val == 'OPERATIONAL' ? '' : 'OPERATIONAL')}
              />
            </Col>
            <Col md={8} className='p-0'>
              <label className='mt-2'>Operational Need / Coverage Change</label>
            </Col>
          </Row>
        </Col>

        <Col md={12}>
          <Row>
            <Col md='auto' className='p-0'>
              <Checkbox label={'hr'}
                checked={reason == 'REFUSAL'}
                onClick={() => setReason((val) => val == 'REFUSAL' ? '' : 'REFUSAL')}
              />
            </Col>
            <Col md={8} className='p-0'>
              <label className='mt-2'>Refusal</label>
            </Col>
          </Row>
        </Col>

        <Col md={12}>
          <Row>
            <Col md='auto' className='p-0'>
              <Checkbox label={'hr'}
                checked={reason == 'NOSHOW'}
                onClick={() => setReason((val) => val == 'NOSHOW' ? '' : 'NOSHOW')}
              />
            </Col>
            <Col md={8} className='p-0'>
              <label className='mt-2'>No-Show</label>
            </Col>
          </Row>
        </Col>

        <Row>
          <Col md='auto'>
            <ButtonTheme type='submit' variant="filled" color='white' className='mt-4' onClick={() => {
              setDelReasonModal(false)
            }}>
              Cancel
            </ButtonTheme>
          </Col>
          <Col md='auto'>
            <ButtonTheme disabled={reason == ''} type='submit' variant="filled" color='primary' className='mt-4'
              onClick={() => deleteEmpOt(null, true)}
            >
              Delete
            </ButtonTheme>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>

    <Modal show={confirmPTOTypeChangeModal} onHide={() => setConfirmPTOTypeChangeModal(false)} centered>
      <Modal.Header closeButton>
        <Modal.Title>PTO type change</Modal.Title>
      </Modal.Header>
      <Modal.Body>

        <div style={{ color: '#555555' }}>
          You are about to change this employee's time off code from {AbsentReasonAll[origSelectedRow.Absent_Code]} to {AbsentReasonAll[editEvent.type]}. This may impact the employee’s scheduled time off. Do you wish to proceed?
        </div>

        <Row className="mt-4">
          <Col md="auto">
            <ButtonTheme
              variant="filled"
              color="white"
              onClick={() => {
                setConfirmPTOTypeChangeModal(false)
              }}
            >
              Cancel
            </ButtonTheme>
          </Col>

          <Col md="auto">
            <ButtonTheme
              variant="filled"
              color="primary"
              onClick={() => {
                setSaving(true)
                ApiService.post('/editEmployeesOvertime', { ...editEvent, date: moment(data.date).format('YYYY-MM-DD') })
                  .then((res) => {
                    setEditMode(false);
                    reset()
                    setSaving(false)
                    loadData(moment(data.date).format('DD-MM-YYYY'))
                    toast.success(res?.message)
                    loadEmployee()
                    setSelectedShifts([])
                    setKeepHours(defaultKeepHours)
                    setConfirmPTOTypeChangeModal(false);
                    setEditEvent('')
                    setOrigSelectedRow('')
                    backFunction();
                  }).catch((error) => {
                    setSaving(false)
                    toast.error(error?.data?.message)
                  })
              }}
            >
              Confirm
            </ButtonTheme>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  </>
}


